import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-family-details',
  templateUrl: './patient-family-details.component.html',
  styleUrls: ['./patient-family-details.component.scss']
})
export class PatientFamilyDetailsComponent implements OnInit {
  user: any = [];
  patientChildren:any = [];

userId:number;
  constructor(
    private userService: UserService,
    private patientService: PatientService,
    private loaderService: WindowLoaderService,
    public dialogRef: MatDialogRef<PatientFamilyDetailsComponent>, // Inject MatDialogRef to close dialog
    @Inject(MAT_DIALOG_DATA) public data: any // Inject data to access passed data

  ) { }

  ngOnInit() {
    this.getUserDetails();

  }
  getUserDetails() {
    this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        console.log("This is userId: ", this.userId);
        this.GetPatientDetailsByUserId();

      },
      (error) => { console.error(error); }
    );
  }
  GetPatientDetailsByUserId() {
    this.loaderService.show();
    this.patientService.getPatientDetailsByUserId(this.userId).subscribe(
      (result) => {
        console.log("patient id Details:", result);
            // Set the active status and subscriptionTypeId from the API response
        this.patientChildren = result.patientChildren;
  
    
        this.loaderService.hide();

      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.loaderService.hide();
      }
    );
  }
   // Method to handle the "Okay" button click
   onOkay(): void {
    const selectedMembers = this.patientChildren.filter((member) => member.selected);
    this.dialogRef.close(selectedMembers); // Pass selected members back to the parent component
  }

  onCancel(): void {
    this.dialogRef.close(); // Close without returning data
  }
}
